
import { ExclamationCircleIcon, CheckCircleIcon, AdjustmentsHorizontalIcon, ChevronDoubleUpIcon } from '@heroicons/react/24/solid'

const NoVideosFound = () => {
  return (
    <div>
      <div className="bg-white shadow-lg rounded-lg p-8 max-w-md text-center">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Your search did not match any videos.
        </h2>
        <div className="text-gray-600">
          <p className="mb-2">Suggestions:</p>
          <ul className="list-none space-y-2 text-left">
            <li className="flex items-center">
              <ExclamationCircleIcon className="h-5 w-5 text-gray-500 mr-2" aria-hidden="true" />
              Make sure that all words are spelled correctly.
            </li>
            <li className="flex items-center">
              <CheckCircleIcon className="h-5 w-5 text-gray-500 mr-2" aria-hidden="true" />
              Try different keywords.
            </li>
            <li className="flex items-center">
              <AdjustmentsHorizontalIcon className="h-5 w-5 text-gray-500 mr-2" aria-hidden="true" />
              Try more general keywords.
            </li>
            <li className="flex items-center">
              <ChevronDoubleUpIcon className="h-5 w-5 text-gray-500 mr-2" aria-hidden="true" />
              Try fewer keywords.
            </li>
          </ul>
          <p className="mt-4 text-sm text-gray-500">
            Tip: use tags by typing #, like #2026 or #JohnDoe.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NoVideosFound;
